import { useNavigate } from "react-router-dom";
import { FallbackProps } from "react-error-boundary";
import { Button, Box, Typography, Stack } from "@mui/material";
import { Refresh, Home } from "@mui/icons-material";

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        p: 2,
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 1, fontWeight: "bold" }}>
          Something went wrong
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {error.message}
        </Typography>
      </Box>

      <Stack direction="row" spacing={2}>
        <Button
          variant="outlined"
          onClick={() => {
            resetErrorBoundary();
            window.location.reload();
          }}
          startIcon={<Refresh />}
        >
          Try again
        </Button>

        <Button
          variant="contained"
          onClick={() => {
            navigate("/clients");
            resetErrorBoundary();
          }}
          startIcon={<Home />}
        >
          Go to Home
        </Button>
      </Stack>
    </Box>
  );
}
